import React from "react";
import { Link } from "lib/router";
import { ArrowLeft } from "lucide-react";
import { buttonVariants } from "ui";

function PageNotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
      <span className="font-mono text-[13px] font-medium text-accent">404</span>
      <h1 className="m-0 mt-2 text-[28px] font-semibold tracking-tight text-fg">Page not found</h1>
      <p className="m-0 mt-2 max-w-md text-[14px] text-muted">The page you are looking for might be under construction or does not exist.</p>
      <Link to="/dashboard" className={buttonVariants({ variant: "primary", size: "lg", className: "mt-6 no-underline" })}>
        <ArrowLeft /> Go to Dashboard
      </Link>
    </div>
  );
}

export default PageNotFound;
